export const WeaveMark = ({ size = 26, className = "" }) => (
  <img
    src="/assets/weave-mark.webp"
    alt=""
    aria-hidden="true"
    width={size}
    height={size * 0.707}
    className={`object-contain ${className}`}
  />
);

export const WeaveLogo = ({ dark = false, height = 30 }) => (
  <img
    src="/assets/weave-logo.png"
    alt="The Weave"
    data-testid="weave-logo"
    style={{ height, width: "auto" }}
    className="object-contain"
  />
);
